import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ConfigurationService } from '@shared/services/configuration.service';

@Component({
  selector: 'home-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrl: './countdown-timer.component.scss',
  standalone: false
})
export class CountdownTimerComponent implements OnInit, OnDestroy {

  @Input() startTime: Date;

  // Configuration
  cfgCountdownAlertMinutes: number | null = null;
  keyCountdownAlertMinutes = 'CONTEST-ROUND-COUNTDOWN-ALERT-MINUTES';

  // Model
  displayTimer: string = '';
  intervalId: any | null = null;
  isAlert = false;

  constructor(
    private configurationService: ConfigurationService
  ) { }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnInit() {

    // Get countdown configuration
    this.configurationService.getItem(this.keyCountdownAlertMinutes)
      .subscribe((value) => this.cfgCountdownAlertMinutes = +value.Value);

    // Update displayed time
    this.updateTimes();

    // Start regularly checking the time
    if (!this.intervalId) {
      this.intervalId = setInterval(() => this.updateTimes(), 1000);
    }
  }

  private updateTimes() {

    const now = new Date().getTime();
    const diff = Math.abs(this.startTime.getTime() - now);

    if (diff > 86400000) {
      const days = Math.floor(diff / 86400000);
      this.displayTimer = `${days} day${days > 1 ? 's' : ''}`;
    } else {
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      this.displayTimer = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      if (this.cfgCountdownAlertMinutes) {
        this.isAlert = minutes < this.cfgCountdownAlertMinutes;
      }
    }
  }
}
